<template>
    <b-row class="pmis-features-padding">
        <pmis-feature-item pic="analytics">analitika in vizualizacija</pmis-feature-item>
        <pmis-feature-item pic="mass-processing">obdelava mas. podatkov</pmis-feature-item>
        <pmis-feature-item pic="dashboard">nadzorne plošče</pmis-feature-item>
        <pmis-feature-item pic="digital-market">digitalne tržnice</pmis-feature-item>
        <pmis-feature-item pic="capture">zajem in int. podatkov</pmis-feature-item>
        <pmis-feature-item pic="iot-management">upravljanje z IoT</pmis-feature-item>
        <pmis-feature-item pic="storage">hramba podatkov</pmis-feature-item>
        <pmis-feature-item>drugo</pmis-feature-item>
    </b-row>
</template>

<script>
    import PmisFeatureItem from "./PmisFeatureItem";

    export default {
        name: "PmisFeatures",
        components: {PmisFeatureItem}
    }
</script>

<style lang="scss" scoped>
    .pmis-features-padding {
        padding-left: 15px;
        padding-right: 25px;
        padding-top: 15px;
        margin-bottom: 20px;
    }
</style>
